import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { lastValueFrom, map } from 'rxjs';
import { GiftCycleControllerService, GiftCycleResponseDTO } from 'src/app/admin-api';
import { TableColumn } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-mgm',
  templateUrl: './mgm.component.html',
  styleUrl: './mgm.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MgmComponent implements OnInit {
  private giftCycleService = inject(GiftCycleControllerService);
  private title = inject(Title);

  cycles: GiftCycleResponseDTO[] = [];

  columns = [
    new TableColumn.Builder()
      .setHeader('ID')
      .setField('giftCycleId')
      .setRouterLink((c: GiftCycleResponseDTO) => `/marketing/mgm/${c.giftCycleId}`)
      .setFilter(false)
      .build(),
    new TableColumn.Builder()
      .setHeader('Mês de Referência')
      .setField('referenceMonth')
      .setType('text')
      .setDisplayFunction((c: GiftCycleResponseDTO) => this.formatReferenceMonth(c.referenceMonth))
      .setFilter(true)
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('referenceMonth')
      .setType('status')
      .setStatusFunction((c: GiftCycleResponseDTO) => {
        const current = this.currentReferenceMonth();
        const ref = c.referenceMonth;
        if (!ref || ref < current) return -1;
        if (ref === current) return 1;
        return 0;
      })
      .setDisplayFunction((c: GiftCycleResponseDTO) => {
        const current = this.currentReferenceMonth();
        const ref = c.referenceMonth;
        if (!ref || ref < current) return 'Fechado';
        if (ref === current) return 'Ativo';
        return 'Agendado';
      })
      .setFilter(false)
      .build(),
    new TableColumn.Builder()
      .setHeader('Brindes')
      .setField('giftsCount')
      .setType('text')
      .setDisplayFunction((c: GiftCycleResponseDTO) => String(c.gifts?.length ?? 0))
      .setFilter(false)
      .build(),
    new TableColumn.Builder()
      .setHeader('Criado em')
      .setField('dateCreated')
      .setType('date')
      .setDisplayFunction((c: GiftCycleResponseDTO) => this.formatDate(c.dateCreated))
      .setFilter(false)
      .build()
  ];

  async ngOnInit(): Promise<void> {
    this.title.setTitle('Marketing - Brindes MGM');
    await this.loadCycles();
  }

  async loadCycles(): Promise<void> {
    LoaderService.showLoader();
    try {
      this.cycles = await lastValueFrom(
        this.giftCycleService.listCycles().pipe(map((data) => data.result))
      );
    } catch (error) {
      AppDialogService.showErrorDialog(error, true);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  formatReferenceMonth(ref?: number): string {
    if (!ref) return '-';
    const s = String(ref);
    if (s.length !== 6) return s;
    return `${s.substring(4, 6)}/${s.substring(0, 4)}`;
  }

  private formatDate(d?: Date): string {
    if (!d) return '';
    const date = new Date(d as unknown as string);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('pt-BR');
  }

  private currentReferenceMonth(): number {
    const now = new Date();
    return now.getFullYear() * 100 + (now.getMonth() + 1);
  }
}
